import { Navigate, useParams, useRoutes } from "react-router-dom";

import CorporateActionRoutes from "./corporateAction/routes";
import CurrencyRoutes from "./currency/routes";
import DomicileRoutes from "./domicile/routes";
import ExchangeRoutes from "./exchange/routes";
import HolidayRoutes from "./holiday/routes";
import IndexPage from "./index";

export default () =>
  useRoutes([
    { path: "/holiday/*", element: <WithParameters component={HolidayRoutes}/> },
    { path: "/exchange/*", element: <WithParameters component={ExchangeRoutes}/> },
    { path: "/corporateAction/*", element: <WithParameters component={CorporateActionRoutes}/> },
    { path: "/currency/*", element: <WithParameters component={CurrencyRoutes}/> },
    { path: "/domicile/*", element: <WithParameters component={DomicileRoutes}/> },
    { path: "/", element: <WithParameters component={IndexPage}/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
